class InvoiceTotalCalculatorService extends BaseService
	@register()

	calculate: (invoices = []) ->
		invoices.map (invoice) =>
			totalSum = 0
			processedOrders = {}

			for transaction in invoice.transactions || []
				order = transaction.order
				continue unless order?
				continue if processedOrders[order.id]

				processedOrders[order.id] = true

				for lineItem in order.order_line_items || []
					totalSum += @sumLineItem lineItem

			invoice.total_sum = totalSum / 100

			return invoice

	sumLineItem: (lineItem) ->
		sum = parseInt lineItem.total_line_amount || 0

		for addon in lineItem.addon_line_items || []
			sum += parseInt addon.total_line_amount || 0

		for bundle in lineItem.bundled_line_items || []
			sum += parseInt bundle.total_line_amount || 0

		return sum
